<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ix"></a>
<p class="centerp">TROTSKY’S ‘FATAL’ FAMILY TREE</p>
<div class="image_container">
<img alt="images" src="images/f00ix-01.jpg"/>
<p class="captionf"><em class="italic">Notes</em></p>
<p class="captionf1">Dates in <span class="bold">bold</span> font = shot/assassinated/mysterious circumstances/suicide. ? = fate unknown.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Familytree.vue?034b3468